module.exports = __webpack_public_path__ + "img/btn_income_red.b88dbade.png";